import type { FC, ReactNode } from 'react';
import { useEffect } from 'react';

import { Routes, useCurrentRoute, useUnsafeNavigate } from '@luna/router';

type Props = {
    startRoute: string;
    children: ReactNode;
};

export const FeatureRoutes: FC<Props> = (props) => {
    const navigate = useUnsafeNavigate();
    const currentRoute = useCurrentRoute();

    const { startRoute, children } = props;

    useEffect(() => {
        const currentRouteWithoutQuery = currentRoute.split('?')[0];
        if (currentRouteWithoutQuery.endsWith(startRoute)) {
            return;
        }
        navigate(`../${startRoute}`, { replace: true });
    }, []);

    return <Routes>{children}</Routes>;
};

FeatureRoutes.displayName = 'Routes';
